const vinylSizeOptions = [
  { id: "LARGE", label: "Large", value: 8 },
  { id: "SMALL", label: "Small", value: 4 }
];

export { vinylSizeOptions };
